import React from 'react'
import cn from 'classnames'

import { SIconSpan } from '../../styles/Icons'

export function CloseIcon({ className, size = 22, color, title, id }: IIConProps): React.ReactElement {
    return (
        <SIconSpan title={title} id={id} size={size} className={cn(className)}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 22 22"
                fill={color ?? 'currentcolor'}
                data-tesid="close-icon"
                version="1.1"
                id="svg182"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_2_49)" id="g175">
                    <path
                        d="m 10,11 c 0,1.07 -0.41999,2.07 -1.16999,2.83 l -4.17,4.17 h -2.84 l 5.59,-5.59 c 0.38,-0.37 0.59,-0.88 0.59,-1.41 0,-0.53 -0.21,-1.04 -0.59,-1.41 L 1.82001,4 h 2.84 l 4.17,4.17 C 9.58001,8.93 10,9.93 10,11 Z"
                        id="path171"
                    />
                    <path
                        d="M 14.59,12.41 20.18,18 H 17.34 L 13.17,13.83 C 12.42,13.07 12,12.07 12,11 12,9.93 12.42,8.93 13.17,8.17 L 17.34,4 h 2.84 L 14.59,9.59 C 14.21,9.96 14,10.47 14,11 c 0,0.53 0.21,1.04 0.59,1.41 z"
                        id="path173"
                    />
                </g>
                <defs id="defs180">
                    <clipPath id="clip0_2_49">
                        <rect width="22" height="22" fill="white" id="rect177" />
                    </clipPath>
                </defs>
            </svg>
        </SIconSpan>
    )
}
